import React from 'react';
import {
  View, StyleSheet, ViewStyle, Text,
} from 'react-native';
import Colors from '../../../constants/Colors';
import DateLabel from '../DateLabel';
import WeatherDashboardItem from './components/WeatherTile';
import { DEFAULT_WEATHER_DATA, WeatherDataItem, WeatherWidgetSize } from './data';
import ScrollViewStyled from '../../ScrollViewStyled';

interface WeatherDashboardProps {
  title?: string,
  style?: ViewStyle | ViewStyle[],
  data?: WeatherDataItem[],
  size?: WeatherWidgetSize,
}

const WeatherDashboard = ({
  title = 'Weather data', style, data = DEFAULT_WEATHER_DATA, size = WeatherWidgetSize.LARGE,
}: WeatherDashboardProps) => {
  if (!(data?.length > 0)) return null;

  const Items = () => <>
    {data.map(({ date, temperature, condition }: WeatherDataItem, index) => <WeatherDashboardItem
      {...{ date, temperature, condition }}
      style={size === WeatherWidgetSize.MEDIUM ? styles.itemMedium : styles.itemLarge}
      key={`weather_dashboard_item_${index}`}
    />)}
  </>;

  return <View
    style={[
      styles.container,
      size === WeatherWidgetSize.MEDIUM && styles.containerMedium,
      size === WeatherWidgetSize.LARGE && styles.containerLarge,
      style,
    ]}
  >
    <View>
      {title?.length > 0 && <Text style={styles.title}>{title}</Text>}
      <DateLabel style={styles.dataDate} />
    </View>
    {size === WeatherWidgetSize.SINGLE && <WeatherDashboardItem
      {...data[0]}
      style={styles.itemSingle}
    />}
    {size === WeatherWidgetSize.MEDIUM && <View style={styles.mediumList}>
      <Items />
    </View>}
    {size === WeatherWidgetSize.LARGE && <ScrollViewStyled horizontal>
      <Items />
    </ScrollViewStyled>}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue50,
    backgroundColor: '#FFF',
    paddingTop: 16,
    marginBottom: 40,
    alignSelf: 'flex-start',
    justifyContent: 'space-between',
    maxWidth: '100%',
  },
  containerMedium: {
    width: 542,
    minHeight: 542,
  },
  containerLarge: {
    paddingBottom: 16,
  },
  title: {
    fontSize: 18,
    lineHeight: 27,
    color: Colors.light.hereworksBlack400,
    fontFamily: 'Poppins_400Regular',
    marginBottom: 4,
    marginHorizontal: 16,
  },
  dataDate: {
    marginBottom: 24,
    marginHorizontal: 16,
  },
  itemSingle: {
    width: 227,
    height: 152,
    marginBottom: 16,
    marginHorizontal: 16,
  },
  itemMedium: {
    width: 120,
    height: 120,
    marginBottom: 8,
  },
  itemLarge: {
    width: 148,
    height: 152,
  },
  mediumList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingBottom: 8,
    paddingHorizontal: 12,
  },
  icon: {
    width: 32,
    height: 32,
    marginEnd: 8,
  },
});

export default WeatherDashboard;
